import { render, staticRenderFns } from "./ProcessDetail.vue?vue&type=template&id=29e20810&scoped=true&"
import script from "./ProcessDetail.vue?vue&type=script&lang=js&"
export * from "./ProcessDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e20810",
  null
  
)

export default component.exports